import { makeStyles, Theme } from '@material-ui/core';
import { RADIUS } from '../../theme/CustomThemeProvider';
import { EmptyCell } from './EmptyCell';

const useStyles = makeStyles((theme: Theme) => ({
  pills: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  pill: {
    padding: theme.spacing(0, 1),
    borderRadius: RADIUS.full,
    fontSize: 12,
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
  },
}));

export function TagPills({ tags }: { tags?: string[] }) {
  const classes = useStyles();
  if (!tags?.length) {
    return <EmptyCell />;
  }
  return (
    <div className={classes.pills}>
      {tags.map(tag => (
        <span key={tag} className={classes.pill}>
          {tag}
        </span>
      ))}
    </div>
  );
}
